import { useContext } from 'react';
import { ExtensionEditorSDK } from '@wix/platform-editor-sdk';

import { ExtensionDataContext } from '../../components/extension/ExtensionDataContext';

export const useEditorSDK = (): ExtensionEditorSDK =>
  useContext(ExtensionDataContext).editorSDK;
